import Component from '@bythepixel/component-loader';
import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';

export default class BasicMap extends Component {
  static selector = '[data-comp-basic-map]'
  static loaderPriority = 'in-view';

  constructor(containerEl) {
    super(containerEl);
    this.latitude = this.$container.dataset.latitude;
    this.longitude = this.$container.dataset.longitude;
    this.createMap();
    this.addMarker();
  }

  createMap() {
    mapboxgl.accessToken = GotBands.mapboxAccessToken;
    this.map = new mapboxgl.Map({
      container: this.$container,
      style: 'mapbox://styles/mapbox/dark-v10',
      center: [this.longitude, this.latitude],
      zoom: 11
    });
  }

  addMarker() {
    const marker = new mapboxgl.Marker({element: this.createMarkerPin()})
      .setLngLat([this.longitude, this.latitude])
      .addTo(this.map);
  }

  createMarkerPin() {
    const iconUrl = window.location.origin + '/static/img/pin-marker.svg';
    const el = document.createElement('div');

    Object.assign(el.style, {
      backgroundImage: `url(${iconUrl})`,
      backgroundSize: 'contain',
      width: '3rem',
      height: '3rem',
      backgroundPosition: 'center bottom',
      backgroundRepeat: 'no-repeat',
    });

    return el;
  }
}
